(function ($) {
	$('.projects-search-form').on('submit', function(e){
		e.preventDefault();
		$('.search-form-wrapper').addClass('search-active');
		filter_projects();
	});
	$('.projects-search-form .btn-clear').on('click', function(e){
		e.preventDefault();
		$('.project-keyword').val('');
		$('.search-form-wrapper').removeClass('search-active');
		filter_projects();
	});

	$('.project-sector').on('change', function(e){
		e.preventDefault();
		filter_projects();
		filter_region_dropdown();
	});

	$('.project-region').on('change', function(e){
		e.preventDefault();
		filter_projects();
		filter_sector_dropdown();
	});

	function filter_projects(){
		var data = {
			'action': 'filter_projects',
			'security': js_params.ajax_nonce,
			'query': $("#h_posts").val(), // that's how we get params from wp_localize_script() function
			'sector': $(".project-sector").val(),
			'region': $(".project-region").val(),
			'keyword': $(".project-keyword").val(),
			'page' : 1
		};

		js_params.current_page = 1;

		$.ajax({
			url : js_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$(".loop-wrapper-outer").addClass('loading');
			},
			success : function( data ){
				if( data ) {
					$(".insights-loop").html(data);
				}
				$(".loop-wrapper-outer").removeClass('loading');
			}
		});
	}
	function filter_region_dropdown(){
		var selected_region = $(".project-region").val();

		var data = {
			'action': 'filter_region_dropdown',
			'security': js_params.ajax_nonce,
			'query': $("#h_posts").val(), // that's how we get params from wp_localize_script() function
			'sector': $(".project-sector").val(),
			'region': $(".project-region").val(),
			'keyword': $(".project-keyword").val()
		};

		$.ajax({
			url : js_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			dataType: 'json',
			beforeSend : function ( xhr ) {
			},
			success : function( data ){
				var select2Instance = $('.project-region').data('select2');
				$('.project-region').empty();

				$.each(data, function(index, value) {
					// console.log(index, value);
					$('.project-region').append(`<option value="${index}">${value}</option>`);
				});

				select2Instance.destroy();
				$('.project-region').select2({
					minimumResultsForSearch: Infinity,
				});

				// if already selected a region previously then set it as selected again
				if( selected_region ) {
					$('.project-region').val( selected_region ).select2({
						minimumResultsForSearch: Infinity,
					});
				}
			}
		});
	}

	function filter_sector_dropdown(){
		var selected_sector = $(".project-sector").val();

		var data = {
			'action': 'filter_sector_dropdown',
			'security': js_params.ajax_nonce,
			'query': $("#h_posts").val(), // that's how we get params from wp_localize_script() function
			'sector': $(".project-sector").val(),
			'region': $(".project-region").val(),
			'keyword': $(".project-keyword").val()
		};

		$.ajax({
			url : js_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			dataType: 'json',
			beforeSend : function ( xhr ) {
			},
			success : function( data ){
				var select2Instance = $('.project-sector').data('select2');
				$('.project-sector').empty();

				$.each(data, function(index, value) {
					// console.log(index, value);
					$('.project-sector').append(`<option value="${index}">${value}</option>`);
				});

				select2Instance.destroy();
				$('.project-sector').select2({
					minimumResultsForSearch: Infinity,
				});

				// if already selected a sector previously then set it as selected again
				if( selected_sector ) {
					$('.project-sector').val( selected_sector ).select2({
						minimumResultsForSearch: Infinity,
					});
				}
			}
		});
	}
})(jQuery);
